import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  resetValue,
  setActive
} from 'actions/meters';

import { RouteSwitch } from 'components';

import { Exit } from 'screens/shared';
import MetersGenStats from './MetersGenStats/MetersGenStats';
import MetersTripStats from './MetersTripStats/MetersTripStats';

class Meters extends Component {
  state = {
    mainRoutes: {
      engineHours: 'engine-hours',
      ptoHours: 'pto-hours'
    },
    tripStatisticsRoutes: {
      tripStatistics0: 'trip-statistics',
      tripStatistics1: 'trip-statistics/1',
      tripStatistics2: 'trip-statistics/2',
      tripStatistics3: 'trip-statistics/3',
      tripStatistics4: 'trip-statistics/4',
      tripStatistics5: 'trip-statistics/5'
    }
  };

  handleReset = (screen, items) => {
    this.props.resetValue({
      screen,
      items
    });
  }

  handleActive = (screen, items) => {
    this.props.setActive({
      screen,
      items
    });
  };

  renderRoutes = (ComponentName, routes) => {
    const { match, content } = this.props;

    return Object.keys(routes).map((key) => {
      const componentProps = {
        id: key,
        content: content[key],
        resetValue: this.handleReset
      };

      if (key.includes('trip')) {
        componentProps.setActive = this.handleActive;
      }

      return (
        <Route
          exact
          path={`${match.url}/${routes[key]}`}
          key={content[key].title}
          render={routeProps =>
            (<ComponentName
              {...routeProps}
              {...componentProps}
            />)}
        />
      );
    });
  }

  render() {
    let { mainRoutes } = this.state;
    const { tripStatisticsRoutes } = this.state;
    const { match, content, flowId } = this.props;
    const { url } = match;

    if (flowId !== 4) {
      mainRoutes = {
        ...mainRoutes,
        fuelEconomy: 'fuel-economy',
        fuelUsed: 'fuel-used'
      };
    }

    let output = <div />;

    if (Object.keys(content).length > 0) {
      output = (
        <RouteSwitch>
          {this.renderRoutes(MetersGenStats, mainRoutes)}
          {this.renderRoutes(MetersTripStats, tripStatisticsRoutes)}
          <Route
            exact
            path={`${url}/exit`}
            render={() =>
              (<Exit
                text={content.exit.title}
                destinations={content.exit.routes}
              />)
            }
          />
          <Redirect from={url} to={`${url}/engine-hours`} />
        </RouteSwitch>
      );
    }

    return output;
  }
}

Meters.defaultProps = {
  content: null
};

Meters.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  content: PropTypes.shape({}),
  flowId: PropTypes.number.isRequired,
  resetValue: PropTypes.func.isRequired,
  setActive: PropTypes.func.isRequired
};

export default connect(({ meters, workflow }) => ({
  content: meters,
  flowId: workflow.id
}), {
  resetValue,
  setActive
})(Meters);



// WEBPACK FOOTER //
// ./src/screens/shared/Meters/Meters.js